/**
 * DownloadModalCtrl
 * Functionality to initiate a download.
 *
 * @author Mark Cremer <mark@firstcoders.co.uk>
 */
angular.module('satv.media')
.controller('DownloadModalCtrl', ['$scope', function($scope) {
    "use strict";
    $scope.download = function(format) {
        $scope.$close(true, {
            format: format
        });
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/controllers/DownloadModalCtrl.js